import styled, { css } from 'styled-components';
import { MdChevronRight } from 'react-icons/md';
import { Link } from 'react-router-dom';

type Selected = {
  selected?: boolean;
  isSelected?: boolean;
};

export const MenuItem = styled.div`
  min-height: 36px;
  margin-bottom: 12px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;

  a {
    text-decoration: none;
  }

  ${({ hidden }) =>
    hidden &&
    css`
      min-height: 0;
      display: none;
    `}
`;

export const MenuItemLink = styled.div<Selected>`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 36px;

  &:hover {
    border-left: 3px solid ${({ theme }) => theme.colors.blueClean};

    & svg {
      color: ${({ theme }) => theme.colors.blueClean} !important;
      margin-left: 19px !important;
    }

    & span {
      color: ${({ theme }) => theme.colors.blueClean} !important;
      font-weight: bold;
    }
  }

  ${({ selected }) =>
    selected &&
    css`
      border-left: 3px solid ${({ theme }) => theme.colors.blueClean};

      & svg {
        color: ${({ theme }) => theme.colors.blueClean} !important;
        margin-left: 19px !important;
      }

      & span {
        color: ${({ theme }) => theme.colors.blueClean} !important;
        font-weight: bold;
      }
    `}
`;

export const LinkCustom = styled(Link)`
  display: flex;
`;

export const SubMenuAction = styled.button`
  display: flex;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  text-align: left;
`;

export const MenuItemText = styled.span<Selected>`
  font-size: 15px;
  color: #fff;
  margin-left: 16px;
  font-family: 'Mangueira';
  flex: 1;

  ${({ isSelected }) =>
    isSelected &&
    css`
      font-weight: bold;
      color: ${({ theme }) => theme.colors.white} !important;
    `}

  &:hover {
    font-weight: bold;
    color: ${({ theme }) => theme.colors.white} !important;
  }

  svg {
    margin-left: auto;
  }
`;

export const AccessibilityReadOnly = styled.span`
  display: none;
  visibility: hidden;
`;

export const ContainerMenuItem = styled.div`
  flex: 1;
`;

type OpenHeight = {
  open?: boolean;
  height?: number;
};

export const SubMenuContainer = styled.div<OpenHeight>`
  display: flex;
  flex-direction: column;

  transition: all 0.5s;
  overflow: hidden;
  max-height: ${({ open, height }) => (open ? `${height}px` : 0)};
  a:first-child,
  button:first-child {
    margin-top: 15px;
  }
  a:last-child,
  button:last-child {
    margin-bottom: 15px;
  }
  a,
  button {
    margin-left: 49px;
  }
  a:not(:last-child),
  button:not(:last-child) {
    margin-bottom: 15px;
  }
`;

export const Arrow = styled(MdChevronRight)<OpenHeight>`
  margin-left: auto;
  margin-right: 15px;
  color: white;
  font-size: 21px;
  transform: rotate(90deg);
  transition: all 0.5s;

  ${({ open }) =>
    open &&
    css`
      transform: rotate(-90deg);
    `}
`;
